import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=1bc790a7&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&lang=js&"
export * from "./CommentDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=1bc790a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc790a7",
  null
  
)

export default component.exports